module.exports = __webpack_public_path__ + "img/420a.417d8c81.png";